import { render, staticRenderFns } from "./UnmergeAliasDialog.vue?vue&type=template&id=5d055866"
import script from "./UnmergeAliasDialog.vue?vue&type=script&lang=js"
export * from "./UnmergeAliasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports